import React from 'react';
import { Modal, Box, SpaceBetween } from '@cloudscape-design/components';
import { Button } from '../Button';

interface ConfirmationModalProps {
  visible: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'primary' | 'secondary';
  loading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  visible,
  title,
  message,
  confirmText,
  cancelText,
  variant = 'primary',
  loading = false,
  onConfirm,
  onCancel,
}) => {
  // Show confirm button if onConfirm callback is provided
  const shouldShowConfirmButton = onConfirm !== undefined;
  const actualConfirmText = confirmText || 'Confirm';
  
  // Show cancel button if onCancel callback is provided
  const shouldShowCancelButton = onCancel !== undefined;
  const actualCancelText = cancelText || 'Cancel';
  
  return (
    <Modal
      visible={visible}
      onDismiss={onCancel}
      header={title}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            {shouldShowCancelButton && onCancel && (
              <Button variant="secondary" onClick={onCancel} disabled={loading}>
                {actualCancelText}
              </Button>
            )}
            {shouldShowConfirmButton && onConfirm && (
              <Button variant={variant} onClick={onConfirm} loading={loading}>
                {actualConfirmText}
              </Button>
            )}
          </SpaceBetween>
        </Box>
      }
    >
      <Box variant="p">{message}</Box>
    </Modal>
  );
};
